import '../App.css';
import celestiaLogo from '../images/celestia/celestia-logo-black.svg';

function Celestia() {
  return (
    <div className="project-page">
      <div className="project-hero">
        <a href="https://celestia.org" target="_blank" rel="noopener noreferrer">
          <img className="project-hero-logo" src={celestiaLogo} alt="Celestia" />
        </a>
        <p className="project-hero-tagline">counterpoint are very proud to have participated as a mainnet validator on the Celestia network</p>
      </div>

      <div className="project-content container">

        <div className="project-card">
          <h3 className="project-card-title">Achievements</h3>
          <ul className="project-list">
            <li>2022 Ran a testnet validator on both Mamaki and its forerunner</li>
            <li>2022-2024 Ran a <a href="https://testnet.mintscan.io/celestia-testnet/validators/celestiavaloper1q4dum94p9xcp4kg4xcdphr3f69uycw7szxppl7">validator</a> on the Mocha test network</li>
            <li>2023-01-18 Invited to participate in the Celestia incentivised testnet</li>
            <li>2023-03-07 Celestia incentivised testnet: <a href="https://blog.celestia.org/the-blockspace-race/">The Blockspace Race</a> starts</li>
            <li>2023-05-15 Blockspace Race <a href="https://blog.celestia.org/a-blockspace-odyssey/">ends</a> with counterpoint in <a href="https://docs.google.com/spreadsheets/d/1NIosukUeILs_Lmdq-g_bN5NDUSiq_SIw_JgOf2UQe9k/edit#gid=0">position 54/100</a></li>
            <li>2023-10-31 counterpoint proud to become a genesis Celestia <a href="https://celestia.explorers.guru/validator/celestiavaloper1vfydl5r98zev8xc7j0mus28r63jcklsu63vuah">validator</a>!</li>
            <li>2024-03-31 We took the decision to shut our validator down to concentrate on other projects. We'd like to thank the Celestia team for the massive learning opportunity, and our delegators while we were active on mainnet. Thank you.</li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default Celestia;
